<template>
    <div class="kgr-row">
        <kgr-form-row
            :label="$t('location.name')"
            :error="error"
            field-name="name"
            required
        >
            <input
                v-model.trim="location.name"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.shortName')"
            :error="error"
            field-name="shortName"
            required
        >
            <input
                v-model.trim="location.shortName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            v-show="isNew"
            :label="$t('location.areaName')"
            :error="error"
            field-name="areaName"
            required
        >
            <input
                v-model.trim="location.areaName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
        <kgr-form-row
            v-show="isNew"
            :label="$t('location.fieldName')"
            :error="error"
            field-name="fieldName"
            required
        >
            <input
                v-model.trim="location.fieldName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.note')"
            :error="error"
            field-name="note"
        >
            <textarea
                v-model.trim="location.note"
                class="kgr-input"
                rows="5"
            ></textarea>
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.type')"
            :error="error"
            field-name="type"
        >
            <input
                v-model.trim="location.type"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.street')"
            :error="error"
            field-name="street"
            required
        >
            <input
                v-model.trim="location.street"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.addressCo')"
            :error="error"
            field-name="addressCo"
        >
            <input
                v-model.trim="location.addressCo"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.postalCode')"
            :error="error"
            field-name="postalCode"
            required
        >
            <input
                v-model.trim="location.postalCode"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.city')"
            :error="error"
            field-name="city"
            required
        >
            <input
                v-model.trim="location.city"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.size')"
            :error="error"
            field-name="size"
        >
            <input
                v-model.number="location.size"
                type="number"
                step="1"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('location.maxPersons')"
            :error="error"
            field-name="maxPersons"
        >
            <input
                v-model.number="location.maxPersons"
                type="number"
                step="1"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';

export default {
    components: {
        'kgr-form-row': FormRow,
    },
    props: {
        location: {
            type: Object,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            isNew: true,
        }
    },
    created(){
        if(this.location.id){
            this.isNew = false;
        }
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
}

</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
